import Loader from "react-loader-spinner";
import { Table, Modal, Button } from 'react-bootstrap';
import { DashCircle, Search, X } from 'react-bootstrap-icons';
import { getCostCenterList } from "../store/api/DocumentsAPI";
import { useEffect, useRef, useState } from "react";
import { translateError } from "../../store/api/CommonFunctions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
const ModalSelectCostCenter = (props) => {
    const searchName = useRef();
    const selectedItem = useRef({});
    const [costCenterList, getCostCenters] = useState([]);
    const { setPopCostCenter, popData } = props;
    const { show, onSelect } = popData;
    const search = (e) => {
        if(e.keyCode && e.keyCode === 27)
        {
            close();
        }
        if (e.key && e.key !== "Enter") {
            return;
        }
        getCostCenterList(searchName.current.value, getCostCenters);
    }
    const close = () => {
        if (onSelect) {
            onSelect(null);
        }
        setPopCostCenter({ show: false });
    }
    const select = (item) => {
        if (onSelect) {
            onSelect(item);
        }
        setPopCostCenter({ show: false });
    }
    useEffect(() => {
        if (searchName.current)
            searchName.current.focus();
    }, [show]);
    return (
        <Modal show={show} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                انتخاب مرکز هزینه
                <span ><FontAwesomeIcon icon={faTimes} size="lg" onClick={close}/></span>
                </Modal.Header>
            <Modal.Body className="bodyStyle">
                <div className="form-group">
                    <input type="text" className="form-control" ref={searchName} placeholder="نام مرکز هزینه" onKeyDown={search} />
                    <Button className="btn-input-tiny" onClick={search} style={{top:"4px", left:"3px"}}><Search size={20} /></Button>
                </div>
                <Table responsive className="mt-2 fixedTable">
                    <thead>
                        <tr>
                            <th style={{ width: "20%" }}>کد مرکز </th>
                            <th style={{ width: "80%" }} scope="col" className="col-3">نام مرکز </th>
                        </tr>
                    </thead>
                    <tbody>
                        {(costCenterList === "PENDING") &&
                            <tr>
                                <td colSpan={2} style={{ textAlign: "center", width: "100%" }}>
                                    <Loader type="BallTriangle" color="rgb(228, 3, 117)" height={20} width={20} />
                                </td>
                            </tr>
                        }
                        {costCenterList && costCenterList.Error &&
                            <tr>
                                <td colSpan={2} style={{ textAlign: "center", color: "red", width: "100%" }}>{translateError(costCenterList.Error)}</td>
                            </tr>
                        }
                        {costCenterList?.Data && Array.isArray(costCenterList.Data) &&
                            costCenterList.Data.map((item, i) =>
                                <tr key={i} className="resultTableRow" onClick={() => select(item)}>
                                    <td style={{ width: "20%" }}>{item.CenterCode}</td>
                                    <td style={{ width: "80%" }}>{item.CenterName}</td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>
                <Button variant="danger" className="group-Btn" onClick={close}><DashCircle size={17}/>&nbsp; انصراف</Button>
            </Modal.Body>
        </Modal>
    )
}
export default ModalSelectCostCenter;